<template>
    <div v-if="isAuthorized">
        <v-main>
            <v-container fluid>
                <v-card id="titlecard" flat>
                    <v-row cols="12" dense>
                        <v-col cols="12">
                            <h2>{{ this.title }}</h2>
                        </v-col>
                    </v-row>
                    <v-row dense cols="12">
                        <v-col cols="4">
                            <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
                        </v-col>
                        <v-col cols="1" ><v-btn class="mt-4 ml-4" color="success" @click="swap">rows<v-icon>mdi-arrow-left-right</v-icon>cols</v-btn></v-col>
                        <v-col cols="1" class="pl-8 pt-6">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-spacer/>
                                    <v-icon v-bind="attrs" v-on="on" medium color="green" v-on:click="exportDataToExcel()">mdi-microsoft-excel</v-icon>
                                </template>
                                <span>Export data to Excel</span>
                            </v-tooltip>
                        </v-col>                                                            
                    </v-row>
                </v-card>
                <v-row class="row-default">
                    <v-col cols="12" class="px-2" v-if="!viewAlt">
                        <v-data-table id="x" 
                            dense 
                            :headers="col_headers" 
                            :items="user_tasks" 
                            :disable-pagination=true
                            hide-default-footer 
                            item-key="gebr_encrid" 
                            :loading="loading"
                            loading-text="Loading data...please wait" 
                            fixed-header 
                            :search="search"
                            :height="wInnerHeight">    
      
   
                            <template v-slot:item="user">
                                <tr>
                                    <td class="td_markup">
                                        {{ user.item.gebr_code }}
                                    </td>
                                    <td class="td_markup">
                                        {{ user.item.gebr_naam }}
                                    </td>
                                    <td class="td_markup">
                                        {{ user.item.gebr_actief }}
                                    </td>
                                    <td class="td_markup" v-for="index in user.item.gebr_auth.length" :key="index">
                                        <v-icon color="green darken-2" v-if="user.item.gebr_auth[index - 1]">mdi-check</v-icon>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" class="px-2" v-if="viewAlt">
                        <v-data-table id="x" 
                            dense 
                            :headers="alt_col_headers" 
                            :items="alt_user_tasks" 
                            :disable-pagination=true
                            hide-default-footer 
                            item-key="taak" 
                            :loading="loading"
                            loading-text="Loading data...please wait" 
                            fixed-header 
                            :search="search"
                            :height="wInnerHeight">    
      
                            <template v-slot:item="elm">
                                <tr>
                                    <td class="td_markup">
                                        {{ elm.item.taak }}
                                    </td>
                                    <td class="td_markup" v-for="index in elm.item.auth.length" :key="index">
                                        <v-icon color="green darken-2" v-if="elm.item.auth[index - 1]">mdi-check</v-icon>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <div>
            <navBar :title="'Ares - Users'" :home="true" type="gebr"/>
        </div>
    </div>
</template>

<script>
    import mxauthorization from '@/mixins/authorization';
    import navBar from '@/components/ui/navbars/navbar.vue';

export default {
    components: {
        navBar,
    },    
    mixins: [mxauthorization],
    data() {
        return {
            search: '',
            isAuthorized: false,
            col_headers: [],
            user_tasks: [],
            alt_col_headers: [],
            alt_user_tasks: [],
            loading: false,
            viewAlt:false,
            wInnerHeight: window.innerHeight - 290, // deduct estimated height for toolbar, searchfield and headers
            title: 'User tasks overview',
        }
    },    
    created() { // set up event bus listener here on created event or get data
        window.addEventListener("resize", this.resizeEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeEventHandler);
    },
    mounted() {
        this.getAuthorization("menu-users-authorizations", "isAuthorized");
    },
    watch:{
        isAuthorized(value) { 
            if (value) {
                // Only get data if the user is authorized
                this.getOverview();
            }           
        },
    }, 
    methods: {     
        resizeEventHandler() {
            this.wInnerHeight = window.innerHeight - 290; // deduct estimated height for toolbar, searchfield and headers
        },
        swap(){
            this.viewAlt = !this.viewAlt;
        },
        getOverview() {
            this.loading = true;
            this.$axios.post("ares/json/ares/syst/authorization/getTaakOverview.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getTaakOverview"
                },
                getTaakOverview: {
                }
            }).then(res => {
                if (res.data.header.result == "error") {
                    console.log(res.data.error);
                } else {
                    this.user_tasks = res.data.getTaakOverview;
                    this.col_headers = [];

                    for (let i = 0; i < res.data.col_headers.length; i++) {
                        let elm =  res.data.col_headers[i];
                        if (i === 0) {
                            this.col_headers.push({ text: elm.code, value: elm.value, sortable: true, width: "10%" })
                        } else if (i === 1) {
                            this.col_headers.push({ text: elm.code, value: elm.value, sortable: true, width: "200px" })
                        } else if (i === 2) {
                            this.col_headers.push({ text: elm.code, value: elm.value, sortable: true, width: "10%" })
                        } else {
                            this.col_headers.push({ text: elm.code, value: elm.value, sortable: false, width: "10%" })
                        }      
                    }      
                    
                    this.alt_col_headers = [];
                    this.alt_user_tasks = [];

                    this.alt_col_headers.push({ text: "Task", value: "task", sortable: true, width: "300px" })
                    
                    for (let i = 0; i < this.user_tasks.length; i++) {
                        let elm = this.user_tasks[i];
                        this.alt_col_headers.push({ text: elm.gebr_code, value: elm.gebr_code, sortable: false, width: "10%" })    
                    } 

                    for (let i = 3; i < this.col_headers.length; i++) {
                        let elm = this.col_headers[i];
                        let new_elm = { taak: elm.text, auth: [] }
                        
                        for (let j = 0; j < this.user_tasks.length; j++) {
                            new_elm.auth.push(this.user_tasks[j].gebr_auth[i-3]);
                        }   
                        this.alt_user_tasks.push(new_elm);
                    }    

                    this.loading = false;        
                }
            })
        },             
        exportDataToExcel() {

            let user_array=[];

            if (!this.viewAlt) {
                for(let index = 0; index < this.user_tasks.length; index++) {
                    
                    let user_auth = new Object();

                    user_auth["UserCode"]=this.user_tasks[index].gebr_code;
                    user_auth["UserName"]=this.user_tasks[index].gebr_naam;
                    user_auth["UserActive"]=this.user_tasks[index].gebr_actief;

                    for(let auth_index = 0; auth_index < this.user_tasks[index].gebr_auth.length; auth_index++) { 
                        user_auth[this.col_headers[auth_index + 3].text]=this.user_tasks[index].gebr_auth[auth_index];
                    }
                    user_array.push(user_auth);
                }
            } else {
                for(let index = 0; index < this.alt_user_tasks.length; index++) {
                    
                    let taak_auth = new Object();

                    taak_auth["Task"]=this.alt_user_tasks[index].taak;

                    for(let auth_index = 0; auth_index < this.alt_user_tasks[index].auth.length; auth_index++) { 
                        taak_auth[this.alt_col_headers[auth_index + 1].text]=this.alt_user_tasks[index].auth[auth_index];
                    }
                    user_array.push(taak_auth);
                }                
            }

            var XLSX = require("xlsx");
            var ws = XLSX.utils.json_to_sheet(user_array);
            var wb = XLSX.utils.book_new();
            
            XLSX.utils.book_append_sheet(wb, ws, "User Authorizations");
            XLSX.writeFile(wb, 'UserAuthorizations.xlsx');
        },
    }
}

</script>

<style scoped> 
    .row-pointer {
        cursor: pointer;
    }

    .row-default {
        cursor: default;
    }
    .td_markup {
        vertical-align: top;
        border-top: 5px solid transparent !important;
        font-size: 12px !important;
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
</style>